// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","submitBtn":"RegularOrderDetailsPage_submitBtn__-shGA"};